import { Component, OnInit, OnDestroy, EventEmitter, Input, Output, ViewEncapsulation, ChangeDetectionStrategy, computed, signal } from '@angular/core'
import { combineLatest, Observable, Subject, takeUntil } from 'rxjs'
import { MaksutapaJaKirjaukset } from './kirjanpito.component'

@Component({
  selector: 'app-kirjanpito-maksutavat',
  templateUrl: './kirjanpito-maksutavat.component.html',
  styleUrls: ['./kirjanpito-maksutavat.component.css'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class KirjanpitoMaksutavatComponent implements OnInit, OnDestroy {
  @Input() rivinKirjauksetMaksutavoittainObservable: Observable<MaksutapaJaKirjaukset[]>
  @Input() naytaVeroilmoitusValilehtiObservable: Observable<boolean>
  @Output() valittuMaksutapa = new EventEmitter<MaksutapaJaKirjaukset>()

  private _ngUnsubscribe: Subject<void> = new Subject<void>()
  readonly rivinKirjauksetMaksutavoittain = signal<MaksutapaJaKirjaukset[]>([])
  readonly riviNames = computed(() => this.rivinKirjauksetMaksutavoittain().map(item => this.maksuTavanNimi(item.maksutapa.nimi, 20)))

  constructor() {}

  ngOnInit() {
    combineLatest([this.rivinKirjauksetMaksutavoittainObservable])
      .pipe(takeUntil(this._ngUnsubscribe))
      .subscribe(([rivinData]) => {
        this.rivinKirjauksetMaksutavoittain.set([...this.sortMaksutavat(rivinData)])
      })
  }

  private sortMaksutavat(maksutavat: any[]): any[] {
    return maksutavat.sort((a, b) => {
      const aCount = a.kasiteltyja + a.kasittelematta
      const bCount = b.kasiteltyja + b.kasittelematta
      return aCount === bCount ? 0 : aCount === 0 ? 1 : bCount === 0 ? -1 : 0
    })
  }

  ngOnDestroy() {}

  vaihdaValittuMaksutapa(maksutapaJaKirjaukset: MaksutapaJaKirjaukset) {
    this.valittuMaksutapa.emit(maksutapaJaKirjaukset)
  }

  maksuTavanNimi(text: string, maxLength: number): string {
    if (text.length <= maxLength) {
      return text
    }
    const visibleEndLength = 4
    const visibleStartLength = maxLength - visibleEndLength - 3
    return text.slice(0, visibleStartLength) + '...' + text.slice(text.length - visibleEndLength)
  }
}
